import React, { useState, useRef, useEffect } from "react";
import AttendanceItem from "./AttendanceItem";
import "./AttendanceRecord.css";
import BottomMenu from "../layout/bottomMenu";
import Loader from "../../Loader/Loader";

const AttendanceRecord = ({ records, getMonthsFilter, getDaysData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterInputList, setFilterInputList] = useState([{}]);
  const [open, setOpen] = useState(false);

  const currentMonth = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();

  const handleFilter = async (key, value) => {  
    const [month, year] = value.split("-");
  
    const list = [...filterInputList];
    list[0][key] = month; 
    list[0]['year'] = year; 
    
    setFilterInputList(list);
  };
  
  const handleSubmitFilter = async () => {
    const listStatus = [0];
    localStorage.setItem(
      "regularization_filters",
      JSON.stringify(filterInputList)
    );
    setOpen(false);
    setIsLoading(true);
    await getDaysData(filterInputList[0]?.months, filterInputList[0]?.year);
    setIsLoading(false);
  };
  

  const handleRemoveFilter = async (key) => {
    const listStatus = [0];
    if (key !== "") {
      if (filterInputList === undefined || filterInputList === null) {
        delete window.localStorage.regularization_filters;
      }
      delete filterInputList[0][key];
      setFilterInputList(filterInputList);
      setIsLoading(true);
      await getDaysData(currentMonth, currentYear);
      setIsLoading(false);
    }
  };

  const monthNumber = filterInputList[0]?.months || currentMonth;
  const year = currentYear;
  let monthName = "";

  if (monthNumber) {
    const date = new Date(year, monthNumber - 1);
    monthName = date.toLocaleString("default", { month: "long" });
  }

  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  

  return (
    <>
      <Loader isLoading={isLoading} />
      {filterInputList[0] !== undefined &&
      Object.keys(filterInputList[0]).length > 0 ? (
        <>
          <div className="d-sm-flex align-items-center justify-content-between mr-6">
            <div className="row pd-filter-div">
              <div className="col-md-12 col-sm-12 d-flex">
              <div className="applied-filter mt-3">
                {(() => {
                  const month = parseInt(filterInputList[0].months, 10) - 1;
                  const year = filterInputList[0].year;
                  const displayValue = `${monthNames[month]} ${year}`;

                  return (
                    <span className="fd-1">
                      <span>{displayValue}</span>
                      <i
                        className="bi bi-x-circle"
                        onClick={() => {
                          handleRemoveFilter("months");
                          handleRemoveFilter("year");
                        }}
                      ></i>
                    </span>
                  );
                })()}
              </div>
              </div>
            </div>
          </div>
          <button
            onClick={() => setOpen(!open)}
            className="btn btn-sm btn-primary mr-1 mt-3 btn-filter"
            type="button"
          >
            <i className="fa fa-filter lh-35 pd-3"></i>
          </button>
        </>
      ) : (
      <div className="d-flex" style={{'position': 'relative', 'top': '6px'}}>
          <h5 className="mt-3" style={{'marginLeft': '6rem'}}>{`${monthName} - ${year}`}</h5>
        <button
          onClick={() => setOpen(!open)}
          className="btn btn-sm btn-primary btn-filter"
          type="button"
        >
          <i className="fa fa-filter lh-35 pd-3"></i>
        </button>
      </div>
      )}
      <div className="attendance-record">
        {records?.map((record, index) => (
          <AttendanceItem
            key={index}
            record={record}
            getDaysData={getDaysData}
          />
        ))}
      </div>
      <BottomMenu
        open={open}
        setOpen={setOpen}
        filterContent={getMonthsFilter}
        handleFilter={handleFilter}
        handleSubmitFilter={handleSubmitFilter}
        localstorageKeyRemove={"months_filters"}
      />
    </>
  );
};

export default AttendanceRecord;
